import React, { ReactElement, useEffect } from 'react';
import './Doctors.less';
import { getMappedRoute } from '../../../utils/routeUtility';
import { INVENTORY_DOCTORS_NESTED_ROUTE } from '../../../config/route/NestedRoutesConfig';
import NestedRoute from '../../../shared/components/tabs/NestedRoute';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDoctorsList, saveDoctorsList } from '../../../store/actions/inventoryAction';
import { FETCH_INVENTORY_DASHBOARD } from '../../../shared/constants/urlEndPoints';
import { dashBoardRequest } from '../../../store/actions/leftSideBarAction';
import { INVENTORY_MESSAGE_CONSTANTS, INVENTROY_CONSTANTS } from './../../../shared/constants/commonConstants';

const Doctors = ({ match, location }: any): ReactElement => {
  const nextDefaultPage = getMappedRoute(location?.pathname, INVENTORY_DOCTORS_NESTED_ROUTE) || INVENTORY_DOCTORS_NESTED_ROUTE[0].routeName;
  const dispatch = useDispatch();
  const doctorsDetailList = useSelector(({ inventory: { doctorsList } }: any): any => doctorsList);

  useEffect((): void => {
    if (!doctorsDetailList || (doctorsDetailList && !doctorsDetailList.length && !doctorsDetailList.error)) {
      dispatch(fetchDoctorsList({}));
    }
  }, [doctorsDetailList]);

  useEffect((): void => {
    dispatch(saveDoctorsList([]));
    dispatch(dashBoardRequest({
      title: INVENTORY_MESSAGE_CONSTANTS.title.doctors,
      url: `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${FETCH_INVENTORY_DASHBOARD}`, type: INVENTROY_CONSTANTS.doctor,
    }));
  }, []);

  return (
    <NestedRoute
      match={match}
      defaultPage={nextDefaultPage}
      nestedNav={INVENTORY_DOCTORS_NESTED_ROUTE} />
  );
};

export default Doctors;
